var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "top" } }, [
    _c("section", { staticClass: "ttl_area" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("h1", { staticClass: "smoothing_off" }, [_vm._v("ARAI'S PORTFOLIO")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: _vm.ichigo_gif_src,
          width: "65",
          height: "auto",
          alt: "ICHIGODAIHUKU"
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "ttl_note" }, [
        _vm._v("\n\t\t\t\tようこそ♪"),
        _c("br"),
        _vm._v(
          "\n\t\t\t\tこのホームページは管理人\tＡＲＡＩのポートフォリオです。"
        ),
        _c("br"),
        _vm._v("\n\t\t\t\t荒らし＆キリ番踏み逃げは禁止です!!"),
        _c("br"),
        _vm._v("\n\t\t\t\tゆっくりしていってください"),
        _c("img", {
          attrs: {
            src: _vm.yaan_gif_src,
            width: "auto",
            height: "24",
            alt: "YAAN"
          }
        })
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "access_counter" }, [
        _vm._v(_vm._s(_vm.countList.total))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "marquee_area" }, [
      _c("p", { staticClass: "marquee_txt" }, [
        _vm._v(
          "♪♪♪こんにちは!!あなたは本日" +
            _vm._s(_vm.countList.daily) +
            "人名のお客様です♪♪♪"
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("p", { staticClass: "news_text" }, [
      _vm._v("\n      ２０１９／２／８ 更新：リンク集更新しました☆\n      "),
      _c("img", {
        attrs: { src: _vm.new_gif_src, width: "auto", height: "11", alt: "NEW" }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "top_img_area" }, [
      _c("div", { staticClass: "ginziro_img" }, [
        _c("img", {
          attrs: {
            src: _vm.main_image_src,
            width: "300",
            height: "auto",
            alt: "GINZIROU"
          }
        })
      ]),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3)
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "common_table" }, [
      _c("tbody", [
        _vm._m(4),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("ＢＢＳ")]),
          _vm._v(" "),
          _c("td", [
            _vm._v("キリ番踏んだ方はコチラへ報告をお願いします"),
            _c("img", {
              attrs: {
                src: _vm.new_gif_src,
                width: "auto",
                height: "11",
                alt: "NEW"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("ＬＩＮＫＳ")]),
          _vm._v(" "),
          _c("td", [
            _vm._v("リンク集です。相互リンク常時募集しております♪"),
            _c("img", {
              attrs: {
                src: _vm.new_gif_src,
                width: "auto",
                height: "11",
                alt: "NEW"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _vm._m(7)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "since_txt" }, [
      _vm._v("\n\t\t\t\tＬＡＳＴ　ＵＰＤＡＴＥ: ２０１９／２／８"),
      _c("br"),
      _vm._v("\n\t\t\t\tＳＩＮＣＥ: ２０１８／１２／１\n\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "kiriban_notation" }, [
      _vm._v("\n\t\t\tキリ番踏んだ方は必ず"),
      _c("a", { attrs: { href: "./bbs" } }, [_vm._v("「ＢＢＳ」")]),
      _vm._v("にカキコお願いします!"),
      _c("span", { staticClass: "force_color toggle_disp" }, [
        _vm._v("踏み逃げ禁止!!")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hukidashi_jp_only" }, [
      _c("p", [
        _vm._v("\n          Ｓｏｒｒｙ。。。"),
        _c("br"),
        _vm._v("\n          Ｔｈｉｓ Ｈｏｍｅｐａｇｅ ｉｓ"),
        _c("br"),
        _vm._v("\n          Ｊａｐａｎｅｓｅ　Ｏｎｌｙ. \n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hukidashi_about" }, [
      _c("p", [
        _vm._v("\n          実家で飼ってるパピヨン♪"),
        _c("br"),
        _vm._v("\n          名前は"),
        _c("span", { staticClass: "rainbow" }, [_vm._v("『銀次郎』")]),
        _vm._v("です★\n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("ＴＯＰ")]),
      _vm._v(" "),
      _c("td", [_vm._v("このページです！")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("ＡＢＯＵＴ")]),
      _vm._v(" "),
      _c("td", [
        _vm._v(
          "このホームページの概要、注意事項についてです！始めた来た人は必読！"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("ＰＲＯＦＩＬＥ")]),
      _vm._v(" "),
      _c("td", [
        _vm._v(
          "管理人ＡＲＡＩのプロフィールです♪ポートフォリオらしくスキルも掲載してます♪"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("ＣＯＮＴＡＣＴ")]),
      _vm._v(" "),
      _c("td", [
        _vm._v(
          "管理人ＡＲＡＩへの連絡はコチラから！荒らしメール絶対やめてください！！"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }